import { HealthProblemsAnswers } from "@/types/answers";
import { Answers } from "@/utils/AnswersProvider";

const healthProblemsMapped: { [key in HealthProblemsAnswers]?: HealthProblemsAnswers } = {
    [HealthProblemsAnswers.FootPain]: HealthProblemsAnswers.KneePain,
    [HealthProblemsAnswers.LegPain]: HealthProblemsAnswers.KneePain,
    [HealthProblemsAnswers.NeckPain]: HealthProblemsAnswers.ShoulderPain,
    [HealthProblemsAnswers.ElbowPain]: HealthProblemsAnswers.ShoulderPain,
    [HealthProblemsAnswers.ArmPain]: HealthProblemsAnswers.ShoulderPain,
};

export const mapHealthProblemsToSupportedByApp = (ans: Answers) => {
    return Array.isArray(ans.health_problems)
        ? [
              ...new Set(
                  ans.health_problems.map(
                      (problem) => healthProblemsMapped[problem as HealthProblemsAnswers] || problem
                  )
              ),
          ]
        : [];
};
